import { gql } from 'apollo-angular';

export const deleteSchedule = gql`
  mutation deleteSchedule($id: Int!) {
    deleteSchedule(id: $id) {
      id
    }
  }
`;
